<template>
    <dash
        icon="fa fa-user-plus"
        titulo="SOLICITAÇÕES DE ACESSO"
        @click.native="$router.push({ name: 'SolicitacoesAcesso' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from './../../../shared/components/DashComponent'

export default {
	props: {
		qtd: {
			type: Number
		},

		loading: {
			type: Boolean
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
